<script setup>
import AgencyConfirmCancel from "./AgencyConfirmCancel.vue";
import {computed, onMounted} from "vue";
import {useStore} from "vuex";
import OffboardingMessage from "@/components/cancellation/package/OffboardingMessage.vue";

const props = defineProps({
  organisationId: {
    type: Number,
    required: true,
  },
  websitesWithPublishedChanges: {
    type: Array,
    required: true,
  },
  cancellationReasons: {
    type: Array,
    required: true,
  },
  errors: {
    type: Array,
    default: () => {}
  },
  isPackage: {
    type: Boolean,
    required: false,
    default: false,
  },
  isAnnual: {
    type: Boolean,
    required: true
  },
  hasDiscountApplied: {
    type: Boolean,
    required: true
  },
  maxNumberOfDiscountsApplied: {
    type: Boolean,
    required: true,
  },
  enableCancelFlow: {
    type: Boolean,
    default: false,
  },
});

const store = useStore()
const step = computed(() => store.getters['agencyCancellation/currentStep'])

onMounted(() => {
  if (props.websitesWithPublishedChanges.length === 0 && !props.enableCancelFlow) {
    store.dispatch('agencyCancellation/nextStep')
  }
  store.dispatch('agencyCancellation/setOrganisationId', props.organisationId)
  store.dispatch('agencyCancellation/setWebsitesWithPublishedChanges', props.websitesWithPublishedChanges)
  store.dispatch('agencyCancellation/setCancellationReasons', props.cancellationReasons)
  if (props.isPackage) {
    store.dispatch('agencyCancellation/setIsPackage', true);
  }
  store.dispatch('agencyCancellation/setIsAnnual', props.isAnnual)
  store.dispatch('agencyCancellation/setHasDiscountApplied', props.hasDiscountApplied)
  store.dispatch('agencyCancellation/setMaxNumberOfDiscountsApplied', props.maxNumberOfDiscountsApplied)
})

</script>

<template>
  <div class="tailwind">
    <div class="tw-m-auto tw-max-w-default-container tw-rounded-xl tw-bg-white tw-p-8 tw-text-neutral-900">
      <OffboardingMessage
        v-if="step === 1"
        :organisation-id="organisationId"
        :enable-cancel-flow="enableCancelFlow"
      />
      <AgencyConfirmCancel
        v-if="step === 2"
        :errors="errors"
      />
    </div>
  </div>
</template>
